/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Boy_5year_krasnuha(props) {
  const { nodes, materials, animations } = useGLTF('patient/boy_5year_krasnuha.glb')
  const { ref, actions, names, mixer } = useAnimations(animations)

  useEffect(() => {
    props.setAnim(animations)
    actions.rigAction.play()
  }, [actions, names, mixer])

  return (
    <group ref={ref} {...props} dispose={null}>
      <group position={[0, 4.44, -0.26]} rotation={[0.37, 0, 0]}>
        <group position={[0, 1, 0]} rotation={[-0.34, 0, 0]}>
          <group position={[0, 0.66, 0]} rotation={[-0.22, 0, 0]}>
            <group position={[0, 0.81, 0]} rotation={[0.25, 0, 0]}>
              <group position={[0, 0.68, 0]} rotation={[0.38, 0, 0]}>
                <group position={[0, 0.29, 0]} rotation={[-0.05, 0, 0]}>
                  <group position={[0, 0.22, 0]} rotation={[-0.38, 0, 0]}>
                    <group rotation={[0.08, 0, 0]}>
                      <group position={[0, 0.74, 0.74]} rotation={[2.69, 0, 0]}>
                        <group position={[0, 0.16, 0]} rotation={[-0.42, 0, 0]}>
                          <group position={[0, 0.11, 0]} rotation={[1.17, 0, 0]}>
                            <group position={[0, 0.06, 0]} rotation={[0.47, 0, 0]} />
                          </group>
                        </group>
                      </group>
                      <group position={[0, 0.31, 0.84]} rotation={[-1.64, -0.02, -1.3]} />
                      <group position={[0, 0.23, 0.83]} rotation={[-1.5, -0.19, -1.13]} />
                      <group position={[0, -0.01, 0.3]} rotation={[1.52, 0, 0]}>
                        <group position={[0, 0.42, 0]} rotation={[-0.83, 0, 0]} />
                      </group>
                      <group position={[0.58, 0.45, 0.03]} rotation={[-0.23, -0.2, -0.08]}>
                        <group position={[0, 0.17, 0]} rotation={[-0.86, -0.19, -0.22]}>
                          <group position={[0, 0.15, 0]} rotation={[-1.83, -0.5, 0.1]}>
                            <group position={[0, 0.21, 0]} rotation={[-0.71, -0.68, 0.45]} />
                          </group>
                        </group>
                      </group>
                      <group position={[-0.58, 0.45, 0.03]} rotation={[-0.23, 0.2, 0.08]}>
                        <group position={[0, 0.17, 0]} rotation={[-0.86, 0.19, 0.22]}>
                          <group position={[0, 0.15, 0]} rotation={[-1.83, 0.5, -0.1]}>
                            <group position={[0, 0.21, 0]} rotation={[-0.71, 0.68, -0.45]} />
                          </group>
                        </group>
                      </group>
                      <group position={[0, 0.31, 0.84]} rotation={[-1.64, 0.02, 1.3]} />
                      <group position={[0, 0.23, 0.83]} rotation={[-1.5, 0.19, 1.13]} />
                      <group position={[0.38, 0.85, 0.63]} rotation={[-1.06, 0.91, 1.96]}>
                        <group position={[0, 0.07, 0]} rotation={[-0.48, 0.74, 0.04]}>
                          <group position={[0, 0.07, 0]} rotation={[-0.09, 0.4, -0.6]} />
                        </group>
                      </group>
                      <group position={[0.36, 0.72, 0.58]} rotation={[-0.92, 0.91, 1.85]}>
                        <group position={[0, 0.09, 0]} rotation={[-0.3, 0.85, -0.03]}>
                          <group position={[0, 0.07, 0]} rotation={[-0.34, 0.41, -0.6]}>
                            <group position={[0, 0.08, 0]} rotation={[-0.55, 0.59, -0.14]}>
                              <group position={[0, 0.07, 0]} rotation={[1.33, 0.1, -2.44]}>
                                <group position={[0, 0.04, 0]} rotation={[0.41, 0.17, 0.03]}>
                                  <group position={[0, 0.09, 0]} rotation={[0.39, 0.27, 0.37]} />
                                </group>
                              </group>
                            </group>
                          </group>
                        </group>
                      </group>
                      <group position={[-0.38, 0.85, 0.63]} rotation={[-1.06, -0.91, -1.96]}>
                        <group position={[0, 0.07, 0]} rotation={[-0.48, -0.74, -0.04]}>
                          <group position={[0, 0.07, 0]} rotation={[-0.09, -0.4, 0.6]} />
                        </group>
                      </group>
                      <group position={[-0.36, 0.72, 0.58]} rotation={[-0.92, -0.91, -1.85]}>
                        <group position={[0, 0.09, 0]} rotation={[-0.3, -0.85, 0.03]}>
                          <group position={[0, 0.07, 0]} rotation={[-0.34, -0.41, 0.6]}>
                            <group position={[0, 0.08, 0]} rotation={[-0.55, -0.59, 0.14]}>
                              <group position={[0, 0.07, 0]} rotation={[1.33, -0.1, 2.44]}>
                                <group position={[0, 0.04, 0]} rotation={[0.41, -0.17, -0.03]}>
                                  <group position={[0, 0.09, 0]} rotation={[0.39, -0.27, -0.37]} />
                                </group>
                              </group>
                            </group>
                          </group>
                        </group>
                      </group>
                      <group position={[0.09, 1.26, 0.69]} rotation={[-2.7, 1.52, -0.66]}>
                        <group position={[-0.07, 0.02, 0.18]} rotation={[0.15, -0.29, -0.01]}>
                          <group position={[-0.07, 0.05, 0.21]} rotation={[-0.01, -0.57, 0.29]}>
                            <group position={[-0.18, 0.23, 0.38]} rotation={[-0.06, -0.69, -0.15]}>
                              <group position={[0, 0.37, 0]} rotation={[-0.13, -0.26, 0.4]}>
                                <group position={[0, 0.38, 0]} rotation={[-0.26, -0.64, 0.63]}>
                                  <group position={[0, 0.51, 0]} rotation={[-1.93, 0.24, 1.32]}>
                                    <group position={[0, 0.23, 0]} rotation={[-1.75, -0.16, -0.8]}>
                                      <group position={[0, 0.23, 0]} rotation={[0.22, 0.38, 0.39]}>
                                        <group position={[0, 0.42, 0]} rotation={[1.31, 0.68, 0.23]}>
                                          <group position={[0, 0.3, 0]} rotation={[-2.12, 0.83, 2.46]}>
                                            <group position={[0, 0.23, 0]} rotation={[-0.01, 0.85, -0.74]} />
                                          </group>
                                        </group>
                                      </group>
                                    </group>
                                  </group>
                                </group>
                              </group>
                            </group>
                          </group>
                        </group>
                      </group>
                      <group position={[-0.09, 1.26, 0.69]} rotation={[-2.7, -1.52, 0.66]}>
                        <group position={[0.07, 0.02, 0.18]} rotation={[0.15, 0.29, 0.01]}>
                          <group position={[0.07, 0.05, 0.21]} rotation={[-0.01, 0.57, -0.29]}>
                            <group position={[0.18, 0.23, 0.38]} rotation={[-0.06, 0.69, 0.15]}>
                              <group position={[0, 0.37, 0]} rotation={[-0.13, 0.26, -0.4]}>
                                <group position={[0, 0.38, 0]} rotation={[-0.26, 0.64, -0.63]}>
                                  <group position={[0, 0.51, 0]} rotation={[-1.93, -0.24, -1.32]}>
                                    <group position={[0, 0.23, 0]} rotation={[-1.75, 0.16, 0.8]}>
                                      <group position={[0, 0.23, 0]} rotation={[0.22, -0.38, -0.39]}>
                                        <group position={[0, 0.42, 0]} rotation={[1.31, -0.68, -0.23]}>
                                          <group position={[0, 0.3, 0]} rotation={[-2.12, -0.83, -2.46]}>
                                            <group position={[0, 0.23, 0]} rotation={[-0.01, -0.85, 0.74]} />
                                          </group>
                                        </group>
                                      </group>
                                    </group>
                                  </group>
                                </group>
                              </group>
                            </group>
                          </group>
                        </group>
                      </group>
                      <group position={[0.51, 0.62, 0.34]} rotation={[2.94, -0.89, 1.15]}>
                        <group position={[0, 0.43, 0]} rotation={[2.93, -0.53, 1.8]}>
                          <group position={[0, 0.24, 0]} rotation={[2.59, 0.77, 1.32]} />
                        </group>
                      </group>
                      <group position={[-0.51, 0.62, 0.34]} rotation={[2.94, 0.89, -1.15]}>
                        <group position={[0, 0.43, 0]} rotation={[2.93, 0.53, -1.8]}>
                          <group position={[0, 0.24, 0]} rotation={[2.59, -0.77, -1.32]} />
                        </group>
                      </group>
                      <group position={[0, 0.26, 0.74]} rotation={[-1.46, 0, 0]}>
                        <group position={[0, 0.12, 0]} rotation={[-0.22, 0, 0]} />
                      </group>
                    </group>
                  </group>
                </group>
              </group>
              <group position={[0.09, 0.68, 0.42]} rotation={[-1.61, -0.04, -1.07]}>
                <group position={[0.02, 0.98, -0.14]} rotation={[1.28, 1.11, -2.3]}>
                  <group position={[0, 1.44, 0]} rotation={[0.72, 0.27, 0.06]}>
                    <group position={[0, 1.42, 0]} rotation={[-0.03, -0.21, -0.01]}>
                      <group position={[-0.05, 0.19, 0.16]} rotation={[1.66, 1.32, -1.53]}>
                        <group position={[0, 0.38, 0]} rotation={[0.14, -0.11, 0.11]}>
                          <group position={[0, 0.16, 0]} rotation={[0.17, -0.16, -0.04]} />
                        </group>
                        <group position={[-0.09, -0.03, 0.15]} rotation={[-0.71, 1.21, 1.23]}>
                          <group position={[0, 0.23, 0]} rotation={[-0.05, 0.04, -0.09]} />
                        </group>
                      </group>
                      <group position={[-0.09, 0.21, 0.06]} rotation={[1.67, 1.33, -1.65]}>
                        <group position={[0, 0.37, 0]} rotation={[0.15, -0.23, -0.06]}>
                          <group position={[0, 0.22, 0]} rotation={[0.14, -0.18, 0.04]} />
                        </group>
                      </group>
                      <group position={[-0.09, 0.21, -0.03]} rotation={[1.5, 1.33, -1.58]}>
                        <group position={[0, 0.34, 0]} rotation={[0.05, -0.34, -0.12]}>
                          <group position={[0, 0.18, 0]} rotation={[0.14, -0.1, -0.03]} />
                        </group>
                      </group>
                      <group position={[-0.06, 0.18, -0.12]} rotation={[1.44, 1.33, -1.58]}>
                        <group position={[0, 0.32, 0]} rotation={[0.01, -0.52, -0.2]}>
                          <group position={[0, 0.15, 0]} rotation={[0.17, -0.05, -0.12]} />
                        </group>
                      </group>
                    </group>
                  </group>
                </group>
              </group>
              <group position={[-0.09, 0.68, 0.42]} rotation={[-1.61, 0.04, 1.07]}>
                <group position={[-0.02, 0.98, -0.14]} rotation={[1.28, -1.11, 2.3]}>
                  <group position={[0, 1.44, 0]} rotation={[0.72, -0.27, -0.06]}>
                    <group position={[0, 1.42, 0]} rotation={[-0.03, 0.21, 0.01]}>
                      <group position={[0.05, 0.19, 0.16]} rotation={[1.66, -1.32, 1.53]}>
                        <group position={[0, 0.38, 0]} rotation={[0.14, 0.11, -0.11]}>
                          <group position={[0, 0.16, 0]} rotation={[0.17, 0.16, 0.04]} />
                        </group>
                        <group position={[0.09, -0.03, 0.15]} rotation={[-0.71, -1.21, -1.23]}>
                          <group position={[0, 0.23, 0]} rotation={[-0.05, -0.04, 0.09]} />
                        </group>
                      </group>
                      <group position={[0.09, 0.21, 0.06]} rotation={[1.67, -1.33, 1.65]}>
                        <group position={[0, 0.37, 0]} rotation={[0.15, 0.23, 0.06]}>
                          <group position={[0, 0.22, 0]} rotation={[0.14, 0.18, -0.04]} />
                        </group>
                      </group>
                      <group position={[0.09, 0.21, -0.03]} rotation={[1.5, -1.33, 1.58]}>
                        <group position={[0, 0.34, 0]} rotation={[0.05, 0.34, 0.12]}>
                          <group position={[0, 0.18, 0]} rotation={[0.14, 0.1, 0.03]} />
                        </group>
                      </group>
                      <group position={[0.06, 0.18, -0.12]} rotation={[1.44, -1.33, 1.58]}>
                        <group position={[0, 0.32, 0]} rotation={[0.01, 0.52, 0.2]}>
                          <group position={[0, 0.15, 0]} rotation={[0.17, 0.05, 0.12]} />
                        </group>
                      </group>
                    </group>
                  </group>
                </group>
              </group>
            </group>
          </group>
        </group>
        <group position={[0.64, 0.09, 0.33]} rotation={[2.65, 0.01, -0.12]}>
          <group position={[0, 1.97, 0]} rotation={[0.3, 0.02, 0]}>
            <group position={[0, 1.92, 0]} rotation={[-1.13, -0.09, 0.05]} />
          </group>
        </group>
        <group position={[-0.64, 0.09, 0.33]} rotation={[2.65, -0.01, 0.12]}>
          <group position={[0, 1.97, 0]} rotation={[0.3, -0.02, 0]}>
            <group position={[0, 1.92, 0]} rotation={[-1.13, 0.09, -0.05]} />
          </group>
        </group>
      </group>
      <group name="rig">
        <primitive object={nodes.root} />
        <primitive object={nodes['MCH-upper_arm_ik_targetparentL']} />
        <primitive object={nodes['MCH-upper_arm_ik_targetparentR']} />
        <primitive object={nodes['MCH-torsoparent']} />
        <primitive object={nodes['MCH-hand_ikparentL']} />
        <primitive object={nodes['MCH-hand_ikparentR']} />
        <primitive object={nodes['MCH-foot_ikparentL']} />
        <primitive object={nodes['MCH-thigh_ik_targetparentL']} />
        <primitive object={nodes['MCH-foot_ikparentR']} />
        <primitive object={nodes['MCH-thigh_ik_targetparentR']} />
        <skinnedMesh
          geometry={nodes.boy5yearseyes.geometry}
          material={materials['Eyebluegreen.001']}
          skeleton={nodes.boy5yearseyes.skeleton}
        />
        <skinnedMesh
          geometry={nodes.boy5years_sculpt001.geometry}
          material={materials['young_asian_female.003']}
          skeleton={nodes.boy5years_sculpt001.skeleton}
        />
        <skinnedMesh
          geometry={nodes.cloth_retopology.geometry}
          material={materials.FABRIC_1_FRONT_164566}
          skeleton={nodes.cloth_retopology.skeleton}
        />
      </group>
    </group>
  )
}

// useGLTF.preload('patient/boy_5year_krasnuha.glb')
